import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";

export const AboutusContent = () => {
  const { t } = useTranslation();
  return (
    <div className="aboutus-content">
      <section>
        <div className="inner">
          <div className="title">{t("about.company.title")}</div>
          <div className="company-warp">
            <div className="company-img">
              <img
                src={
                  "//files.authing.co/authing-website/aboutus-company-v2.jpg"
                }
                alt="authing company"
              />
            </div>
            <div className="company-text">
              <p>{t("about.company.descript-one")}</p>
              <p>{t("about.company.descript-two")}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="process">
        <div className="inner">
          <div className="title">{t("about.process.title")}</div>
          <div className="progress-img">
            <img src={t("about.process.imgUrl")} alt="authing progress" />
          </div>
        </div>
      </section>

      <section className="copyright">
        <div className="inner">
          <div className="title">{t("about.copyright.title")}</div>
          <div className="copryright-box">
            <div className="copryright-item">
              <img
                src={"//files.authing.co/authing-website/copyright-one.jpg"}
                alt="authing copyright"
              />
            </div>
            <div className="copryright-item">
              <img
                src={"//files.authing.co/authing-website/copyright-two.jpg"}
                alt="authing copyright"
              />
            </div>
            <div className="copryright-item">
              <img
                src={"//files.authing.co/authing-website/copyright-tree.jpg"}
                alt="authing copyright"
              />
            </div>
            <div className="copryright-item">
              <img
                src={"//files.authing.co/authing-website/coryright-four.jpg"}
                alt="authing copyright"
              />
            </div>
            <div className="copryright-item">
              <img
                src={"//files.authing.co/authing-website/coryright-five.jpg"}
                alt="authing copyright"
              />
            </div>
            <div className="copryright-item">
              <img
                src={"//files.authing.co/authing-website/copyright-six.jpg"}
                alt="authing copyright"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
